import { FC } from 'react';

import { Box, Drawer, Stack } from '@mui/material';

import { useResponsive } from '@src/hooks/use-responsive';
import { SIDE_BAR } from '@src/layouts/configs';

import SiderBarContent from '../components/sider-bar-content';

type SideBarProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SideBar: FC<SideBarProps> = (props) => {
  const { isOpen, onClose } = props;

  const container =
    window !== undefined ? () => window.document.body : undefined;

  const lgUp = useResponsive('up', 'lg');

  const content = <SiderBarContent />;

  return (
    <Box
      component="nav"
      sx={{
        width: { lg: SIDE_BAR.WIDTH },
        flexShrink: { lg: 0 },
      }}
    >
      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            width: SIDE_BAR.WIDTH,
            borderRight: (theme) =>
              `1px solid ${theme.palette.custom.darkGrey}`,
          }}
        >
          {content}
        </Stack>
      ) : (
        <Drawer
          container={container}
          variant="temporary"
          open={isOpen}
          onClose={onClose}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: SIDE_BAR.WIDTH,
            },
          }}
        >
          {content}
        </Drawer>
      )}
    </Box>
  );
};

export default SideBar;
